<script lang="ts">
    import type {PaymentRequest} from './loadPaymentRequest'
    export let paymentRequest: PaymentRequest
    import Navbar from './Navbar.svelte'
</script>

<Navbar />
<p class="text-center mt-5">Please pay {paymentRequest.amount} to complete your booking for</p>
<p class="text-center"><em>{paymentRequest.description}</em></p>

